import { Box, Button, Typography } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { BackdropLoader } from 'components/@shared/Loaders';
import { CreateHomePageForm } from 'components/Home/CreateHomePageForm';
import { ONLY_ADMIN } from 'constants/roles';
import { useDeniedAccess } from 'hooks/useDeniedAccess';
import { useNotifications } from 'hooks/useNotifications';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes/path';
import { createNewHomePage } from 'services/homePageService';
import { HomePageFormData } from 'types/home-page';

const cardStyles = {
    maxWidth: '700px',
    margin: 'auto',
};

export const AdminCreateHomeImagesPage = () => {
    const [isLoading, setIsLoading] = useState(false);

    const notifications = useNotifications();
    const navigate = useNavigate();

    const updateHandler = (form: HomePageFormData) => {
        setIsLoading(true);
        createNewHomePage(form)
            .then(() => {
                notifications.show({ message: 'Home page successfully created' });
                navigate(PATH.ADMIN_SETTINGS_HOME_PAGE);
            })
            .finally(() => setIsLoading(false));
    };

    useDeniedAccess(ONLY_ADMIN);

    return (
        <Box width="100%" px={2.5} py={2}>
            <Card title="Home Page" sx={cardStyles}>
                <CreateHomePageForm onCreate={updateHandler} />
            </Card>
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
